"use client"

import { X, AlertCircle, CheckCircle2, Info, AlertTriangle } from "@/lib/icons"
import { Button } from "./button"

const ALERT_STYLES = {
  info: {
    icon: Info,
    ring: "ring-blue-500/20",
    iconBg: "bg-blue-50 dark:bg-blue-500/10",
    iconColor: "text-blue-600 dark:text-blue-400",
    button: "bg-blue-600 hover:bg-blue-700 focus-visible:ring-blue-500/40",
  },
  success: {
    icon: CheckCircle2,
    ring: "ring-emerald-500/20",
    iconBg: "bg-emerald-50 dark:bg-emerald-500/10",
    iconColor: "text-emerald-600 dark:text-emerald-400",
    button: "bg-emerald-600 hover:bg-emerald-700 focus-visible:ring-emerald-500/40",
  },
  warning: {
    icon: AlertTriangle,
    ring: "ring-amber-500/20",
    iconBg: "bg-amber-50 dark:bg-amber-500/10",
    iconColor: "text-amber-600 dark:text-amber-400",
    button: "bg-amber-600 hover:bg-amber-700 focus-visible:ring-amber-500/40",
  },
  error: {
    icon: AlertCircle,
    ring: "ring-red-500/20",
    iconBg: "bg-red-50 dark:bg-red-500/10",
    iconColor: "text-red-600 dark:text-red-400",
    button: "bg-red-600 hover:bg-red-700 focus-visible:ring-red-500/40",
  },
}

export function AlertModal({ isOpen, onClose, title, message, type = "info" }) {
  if (!isOpen) return null

  const s = ALERT_STYLES[type] || ALERT_STYLES.info
  const Icon = s.icon

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/40 backdrop-blur-[6px] animate-in fade-in duration-200" onClick={onClose}>
      <div
        className={`relative w-full max-w-xs bg-white dark:bg-slate-900 rounded-2xl shadow-2xl ring-1 ${s.ring} border border-slate-200/60 dark:border-slate-700/60 animate-in zoom-in-95 slide-in-from-bottom-3 duration-300`}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close */}
        <button
          onClick={onClose}
          className="absolute top-3.5 right-3.5 p-1 rounded-full hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors z-10"
        >
          <X className="h-4 w-4 text-slate-400" />
        </button>

        {/* Body */}
        <div className="px-6 pt-7 pb-5 text-center">
          <div className={`mx-auto mb-4 flex h-11 w-11 items-center justify-center rounded-full ${s.iconBg}`}>
            <Icon className={`h-5 w-5 ${s.iconColor}`} />
          </div>
          <h3 className="text-[15px] font-bold text-slate-900 dark:text-slate-100 leading-snug">
            {title}
          </h3>
          <p className="mt-1.5 text-[13px] text-slate-500 dark:text-slate-400 leading-relaxed whitespace-pre-wrap">
            {message}
          </p>
        </div>

        {/* Action */}
        <div className="px-6 pb-5">
          <Button
            onClick={onClose}
            className={`w-full rounded-xl h-10 text-[13px] font-semibold text-white shadow-sm ${s.button}`}
          >
            Entendido
          </Button>
        </div>
      </div>
    </div>
  )
}
